import { PROVIDERS } from "modules/auth/constants";
import {
  FacebookAuthProvider,
  GoogleAuthProvider,
  OAuthProvider,
} from "firebase/auth";

export default (
  providerName: PROVIDERS,
  { prefilledEmail }: { prefilledEmail?: string } = {},
) => {
  switch (providerName) {
    case PROVIDERS.FACEBOOK: {
      const provider = new FacebookAuthProvider();

      provider.addScope("email");
      if (prefilledEmail) {
        provider.setCustomParameters({
          login_hint: prefilledEmail,
        });
      }

      return provider;
    }
    case PROVIDERS.GOOGLE: {
      const provider = new GoogleAuthProvider();

      provider.addScope("email");
      if (prefilledEmail) {
        provider.setCustomParameters({
          login_hint: prefilledEmail,
        });
      }

      return provider;
    }
    case PROVIDERS.MICROSOFT:
      return new OAuthProvider("microsoft.com");
    default:
      throw new Error(`Trying to create unknown provider "${providerName}"`);
  }
};
